import { companyPreviewPanelStore } from "@/stores/company-preview-panel-store";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useTranslation } from "@/hooks/useTranslation";
import { CompanyDTO } from "@shaarp/common";
import { EyeIcon, SearchIcon } from "lucide-react";
import { NavLink } from "react-router-dom";

const CELL_TRIGGER_SEGMENT_CLASS =
  "px-3 transition-colors hover:bg-majorelle/80 outline-none focus-visible:ring-2 focus-visible:ring-ring/50";

export default function DataTableCellCompanySidePanel({
  company,
  getCompanies,
}: {
  company: CompanyDTO;
  /** Lazily resolves the navigable list when the panel opens, so we don't
   *  walk every sorted row on every cell render. */
  getCompanies: () => CompanyDTO[];
}) {
  const { t } = useTranslation();
  const tooltipLabel = t(
    "components.dataTableCompanies.columns.sidePanelTooltip",
  );

  return (
    <div className="inline-flex h-9 items-stretch overflow-hidden rounded-md bg-majorelle text-majorelle-foreground shadow-sm">
      <Tooltip delayDuration={0}>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label={tooltipLabel}
            onClick={() => companyPreviewPanelStore.open(company, getCompanies())}
            className={`flex items-center justify-center ${CELL_TRIGGER_SEGMENT_CLASS}`}
          >
            <EyeIcon className="size-4" />
          </button>
        </TooltipTrigger>
        <TooltipContent>{tooltipLabel}</TooltipContent>
      </Tooltip>
      <div className="my-1.5 w-px bg-majorelle-foreground/30" />
      <NavLink
        to={`/company/${company.id}`}
        target="_blank"
        className={`flex items-center gap-1.5 text-sm font-medium ${CELL_TRIGGER_SEGMENT_CLASS}`}
      >
        <SearchIcon className="size-4" />
        {t("components.dataTableCompanies.columns.consult")}
      </NavLink>
    </div>
  );
}
